module.exports = __webpack_public_path__ + "img/couples-004.77793c74.jpg";